import { Directive, HostListener, Inject, Input } from "@angular/core";
import { ImmutableRedux } from "../../../../redux/immutable-redux.service";
import { GenericFormActions } from "../../actions";
import { FORM_CTAS_STATE_PROP, FORM_STATE_PROP } from "../../state-props";

@Directive({
    selector: "[new-form-cta]",
    exportAs: "NewFormCta",
})
export class NewFormCtaDirective {
    @Input() public stateProp: string;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        @Inject(FORM_STATE_PROP) public formRootProp,
        @Inject(FORM_CTAS_STATE_PROP) public formCtasRootProp,
    ) { }

    @HostListener("click", ["$event"])
    public clickCta(_event) {
        _event.stopPropagation();
        this.dispatchFormOpen({ isNew: true });
    }

    public dispatchFormOpen(payload) {
        this.ngRedux.dispatchFactory(GenericFormActions.FORM_OPENED, this.formRootProp, this.stateProp, payload);
        this.ngRedux.dispatchFactory(GenericFormActions.FORM_OPENED, this.formCtasRootProp, this.stateProp);
    }
}
